export default __webpack_public_path__ + "static/media/MandyLovelace.f238a979.png";